import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import { setUpLocationSync } from '@angular/router/upgrade';
//import { UpgradeModule, setAngularLib } from "@angular/upgrade/static";
// import * as angular from 'angular';
import { Router } from "@angular/router";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

//import { initAngularjs } from './app/common/so-gantt/angularjs';
// setAngularLib(angular);
if (environment.production) {
  enableProdMode();
}

//platformBrowserDynamic().bootstrapModule(AppModule);

// bootstrap Angular 1 application
//initAngularjs();


// platformBrowserDynamic().bootstrapModule(AppModule).then(platformRef => {
//   const upgrade = platformRef.injector.get(UpgradeModule) as UpgradeModule;
//   upgrade.bootstrap(document.documentElement, ['ganttModule']);
//   // setUpLocationSync(upgrade);
// });
 platformBrowserDynamic().bootstrapModule(AppModule)
   .catch(err => console.log(err));
